import moment from 'moment'

const defaultState = {
  subject: '',
  fromDate: moment(),
  toDate: moment(),
  description: '',
  normalSubjects: [],
  personSubjects: [],
  color: 1,
  appointmentPrivate: false
}

export default function reducer(state=defaultState, action) {

    switch (action.type) {
      case "NEW_APPOINTMENT_SET_SUBJECT": {
        return {
          ...state,
          subject: action.payload
        }
      }

      case "NEW_APPOINTMENT_SET_FROM_DATE": {
        return {
          ...state,
          fromDate: action.payload
        }
      }

      case "NEW_APPOINTMENT_SET_TO_DATE": {
        return {
          ...state,
          toDate: action.payload
        }
      }

      case "NEW_APPOINTMENT_SET_DESCRIPTION": {
        return {
          ...state,
          description: action.payload
        }
      }

      case "NEW_APPOINTMENT_ADD_NORMAL_SUBJECT": {
        return {
          ...state,
          normalSubjects: [
            ...state.normalSubjects,
            {type: 1, value: ''}
          ]
        }
      }
      case "NEW_APPOINTMENT_DELETE_NORMAL_SUBJECT": {
        return {
          ...state,
          normalSubjects: state.normalSubjects.filter((_, i) => i !== action.payload)
        }
      }
      case "NEW_APPOINTMENT_UPDATE_NORMAL_SUBJECT": {
        let newNormalSubjects = [...state.normalSubjects]
        newNormalSubjects[action.payload.idx] = action.payload.newSubject
        return {
          ...state,
          normalSubjects: newNormalSubjects
        }
      }

      case "NEW_APPOINTMENT_ADD_PERSON_SUBJECT": {
        return {
          ...state,
          personSubjects: [
            ...state.personSubjects,
            {type: 2, value: ''}
          ]
        }
      }
      case "NEW_APPOINTMENT_DELETE_PERSON_SUBJECT": {
        return {
          ...state,
          personSubjects: state.personSubjects.filter((_, i) => i !== action.payload)
        }
      }
      case "NEW_APPOINTMENT_UPDATE_PERSON_SUBJECT": {
        let newPersonSubjects = [...state.personSubjects]
        newPersonSubjects[action.payload.idx] = action.payload.newSubject
        return {
          ...state,
          personSubjects: newPersonSubjects
        }
      }

      case "NEW_APPOINTMENT_SET_COLOR": {
        return {
          ...state,
          color: action.payload
        }
      }

      case "NEW_APPOINTMENT_SET_PRIVATE": {
        return {
          ...state,
          appointmentPrivate: action.payload
        }
      }

      case "NEW_APPOINTMENT_SET_ERRORS": {
        return {
          ...state,
          error: action.payload
        }
      }

      case "NEW_APPOINTMENT_CLEAR": {
        return {
          ...state,
          subject: '',
          subjectError: false,
          subjectErrorMessage: '',
          fromDate: moment(),
          fromDateError: false,
          fromDateErrorMessage: '',
          toDate: moment(),
          toDateError: false,
          toDateErrorMessage: '',
          description: '',
          normalSubjects: [],
          personSubjects: [],
          color: 1,
          appointmentPrivate: false
        }
      }

      default:{
        return state
      }
    }
}



// WEBPACK FOOTER //
// ./src/js/reducers/newAppointmentReducer.js